module.exports = __webpack_public_path__ + "img/motorbikeOverview4.d212d783.svg";